const CATEGORIES_SC_MAP = {
    '3': ['151', '468'],
    '5': ['335'],
    '10': ['91', '138', '140', '139', '97']
};

const CATEGORIES_NSC_MAP = {
    '10': {
        '91': ['1015', '1017', '1019', '1034'],
        '138': ['1000', '1001', '1002', '1009'],
        '140': ['2040', '2046'],
        '139': ['1007', '1008']
    }
};

const QUERY_LIST = [
    'website',
    'wordpress',
    'shopify',
    'dropshipping',
    'wordpress website design',
    'landing page',
    'website design',
    'website development',
    'wordpress website',
    'website design wordpress',
    'ecommerce website',
    'wix',
    'dropshipping shopify store',
    'web design',
    'business website',
    'woocommerce',
    'wix website design',
    'website shopify',
    'amazon affiliate website',
    'elementor',
    'squarespace',
    'wix website',
    'webflow',
    'one product shopify store',
    'create website',
    'dropshipping store',
    'website',
    'squarespace website design',
    'blog website',
    'shopify website design',
    'woocommerce website',
    'website wordpress',
    'elementor pro',
    'responsive wordpress website',
    'portfolio website',
    'ecommerce',
    'divi',
    'one product shopify dropshipping store',
    'shopify',
    'build website',
    'real estate website',
    'online store',
    'prestashop',
    'ecommerce store',
    'magento',
    'travel website',
    'wordpress',
    'professional wordpress website design',
    'affiliate website',
    'shopify theme',
    'develop website',
    'shopify design',
    'wordpress developer',
    'wordpress landing page',
    'blogger',
    'create online course',
    'web design wordpress',
    'wordpress blog',
    'website design wix',
    'drop shipping',
    'wix website redesign',
    'website builder',
    'woocommerce store',
    'website design',
    'create wordpress website',
    'create shopify store',
    'wordpress design',
    'kajabi',
    'shopify expert',
    'website designer and developer',
    'shopify one product store',
    'clone website',
    'shopify store design',
    'shopify developer',
    'landing page wordpress',
    'landing page design',
    'create shopify dropshipping store',
    'web design and development',
    'elementor landing page',
    'web site',
    'wordpress website development',
    'opencart',
    'dropship',
    'webshop',
    'wordpress site',
    'wordpress ecommerce website',
    'website creation',
    'multi vendor ecommerce marketplace website',
    'website design shopify',
    'psd to wordpress',
    'business wordpress website',
    'dropservicing',
    'dropshipping',
    'website designer',
    'shopify landing page',
    'online shop',
    'elementor website',
    'woocommerce customization',
    'kartra',
    'restaurant website',
    'build shopify store',
    'thrive architect',
    'shopify coding',
    'one product store',
    'wix website builder',
    'websites',
    'weebly',
    'responsive landing page',
    'word press',
    'move wordpress',
    'marketplace',
    'weebly website',
    'one page website',
    'online course website',
    'membership website',
    'design shopify website',
    'develop shopify website',
    'divi website',
    'wordpress landing page design',
    'install wordpress',
    'full website creation',
    'web site design',
    'dropshipping website',
    'redesign wordpress website',
    'shopify dropshipping',
    'website design squarespace',
    'builderall',
    'shopify app',
    'website design godaddy',
    'joomla',
    'build a website',
    'website developer',
    'shopify custom coding',
    'thinkific',
    'squarespace website',
    'landing pages',
    'travel affiliate website',
    'shopify code',
    'design wordpress website',
    'ecommerce wordpress website',
    'bigcommerce',
    'adsense website',
    'landing page',
    'website redesign',
    'amazon store',
    'wix',
    'create blogger site',
    'aliexpress dropshipping',
    'wordpress install',
    'affiliate marketing website',
    'custom website',
    'responsive website',
    'e commerce development service',
    'online store website builder',
    'godaddy website',
    'html to wordpress',
    'webflow website',
    'divi wordpress website',
    'create blog website',
    'wordpress woocommerce',
    'shopify store setup',
    'website wix',
    'mailchimp landing page',
    'design website',
    'alidropship',
    'wix ecommerce',
    'shopify website',
    'podcast website',
    'ecwid',
    'wordpress theme development',
    'wordpress help',
    'build my shopify website',
    'create ecommerce website wordpress',
    'create a website',
    'build wordpress website',
    'wordpress elementor',
    'dropservicing website',
    'subscription website',
    'shopware',
    'shopify conversion',
    'blog wordpress',
    'sales page',
    'ecommerce website developer',
    'clone wordpress website',
    'aliexpress',
    'wordpress blog design',
    'church website',
    'wordpress ecommerce',
    'website maker',
    'e commerce website',
    'professional wordpress website',
    'automated news website',
    'wordpress expert',
    'shopify store',
    'redesign website',
    'drop service',
    'wordpress website',
    'wordpress woocommerce store',
    'godaddy',
    'wix corvid',
    'instabuilder',
    'ecommerce website design',
    'website building',
    'woo commerce',
    'non profit website',
    'autoblog',
    'ecommerce app',
    'responsive web design',
    'dokan',
    'automated dropshipping',
    'freelancer website',
    'wordpress theme install',
    'wordpress landing page elementor',
    'landing pages with elementor',
    'install elementor pro',
    'blog design',
    'design shopify store',
    'convert html to wordpress',
    'store',
    'fitness website',
    'website builders',
    'square space',
    'aliexpress dropshipping store',
    'modern wordpress website design',
    'create responsive wordpress website',
    'design responsive wordpress website',
    'amazon affiliate store',
    'build responsive wordpress website',
    'print on demand store',
    'magento 2',
    'woocommerce product upload',
    'e commerce',
    'landingpage',
    'wordpress membership website',
    'web development wordpress',
    'custom wordpress',
    'wordpress redesign',
    'shopify redesign',
    'duplicate website',
    'kajabi website',
    'personal website',
    'wordpress plugin customization',
    'website build',
    'custom wordpress website',
    'woocomerce',
    'automated website',
    'wix design',
    'real estate landing page',
    'beaver builder',
    'website landing page',
    'multi vendor',
    'woocommerce',
    'magento website',
    'one product dropshipping store',
    'e-commerce',
    'design wix website',
    'wordpress business website',
    'wix landing page',
    'professional website',
    'membership site',
    'wix to wordpress',
    'construction website',
    'wix code',
    'recruitment website',
    'single product shopify store',
    'modern wordpress website',
    'unbounce',
    'wordpress development',
    'wix redesign',
    'shopify store manager',
    'elementor',
    'joomla website',
    'wordpres',
    'website clone',
    'squarespace',
    'redesign wix',
    'website builders and cms',
    'micro niche website',
    'design or redesign wordpress website',
    'elementor wordpress',
    'business wix website',
    'responsive wordpress website design',
    'wordpress setup',
    'auto blog',
    'wordpress web design',
    'website migration',
    'redesign wix website',
    'wordpress autoblog',
    'divi expert',
    'convert psd to wordpress',
    'cms',
    'wix website',
    'wordpress installation',
    'divi builder',
    'divi landing page',
    'divi',
    'clickbank website',
    'xd to wordpress',
    'web site creation',
    'cbd website',
    'i will design wordpress landing page using elementor pro',
    'responsive website design',
    'unbounce landing page',
    'design word press website'
];

module.exports = {
    CATEGORIES_SC_MAP,
    CATEGORIES_NSC_MAP,
    QUERY_LIST
};
